export default __webpack_public_path__ + "static/media/cancel (2).c5d433c3.svg";